<template>
  <!-- 教师专业发展综合积分排行榜 -->
  <div class="top1 clearfix">
    <h1>详细数据统计</h1>
    <div class="big-box clearfix">
      <div
        v-for="(item, index) in listData"
        :key="index"
        :index="index"
        class="box fl clearfix"
      >
        <div class="tu-left tu fl">
          <div style="height: 100%" class="chart-class" ref="chart"></div>
        </div>
        <div class="tu-right tu fl">
          <div style="height: 100%" class="chart-class" ref="chartLine"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    searchYear: null,
    searchTerm: null,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      listData: [],
      defaultUrl: require(`@/assets/image/other/headMan.png`),
      pageObj: {
        current: 1,
        total: 0,
        size: 4,
        sizeList: [4, 8, 12],
      },
    };
  },
  created() {
    this.rankLsit();
  },
  methods: {
    //教师专业发展综合积分排行榜
    rankLsit() {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || null,
        schoolYear: this.searchYear || null,
      };
      this.$axios
        .post("/rpt/getModelCountStatistics", homeForm)
        .then((res) => {
          if (res.resultCode === 200 && res.data.length > 0) {
            this.listData = res.data;
            this.$nextTick(() => {
              this.initCharts();
            });
          } else {
            this.listData = [];
          }
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    initCharts() {
      for (let i = 0; i < this.listData.length; i++) {
        let myChart = this.$echarts.init(this.$refs.chart[i]);
        let chartLine = this.$echarts.init(this.$refs.chartLine[i]);
        chartLine.setOption({
          legend: {},
          tooltip: {
            trigger: "axis",
            showContent: false,
          },
          color: ["#13C2C2", "#2FC25B", "#FACC14", "#F04864", "#8543E0"],
          xAxis: {
            type: "category",
          },
          yAxis: { type: "value", gridIndex: 0 },
          dataset: { source: this.listData[i].lineData },
          series: this.listData[i].lineData
            .slice(0, this.listData[i].lineData.length - 1)
            .map((u) => ({
              type: "line",
              seriesLayoutBy: "row",
              emphasis: { focus: "series" },
            })),
        });
        myChart.setOption({
          color: [
            "#1890FF",
            "#13C2C2",
            "#2FC25B",
            "#FACC14",
            "#F04864",
            "#8543E0",
          ],
          title: [
            {
              text: this.listData[i].name,
              textStyle: {
                fontSize: "15",
                fontWeight: "500",
                color: "#000000",
              },
            },
          ],
          xAxis: {
            type: "category",
            data: this.listData[i]?.barData.map((u) => u.name),
          },
          yAxis: {
            type: "value",
          },

          series: [
            {
              //空白间隙
              itemStyle: {
                normal: {
                  borderColor: "#FFF",
                  borderWidth: 1,
                },
              },
              type: "bar",
              avoidLabelOverlap: false,

              //不显示每一项的介绍
              label: {
                show: false,
              },

              labelLine: {
                show: false,
              },
              data: this.listData[i].barData,
            },
          ],
        });
      }
    },
    checkMore() {
      this.$nextTick(() => {
        // 新增节点后，结构全部渲染后,才能拿到最后的chart节点
        this.rankLsit();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top1 {
  background-color: #fff;
  h1 {
    // border: 1px solid #000;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: @theme-color;
    margin: 0 20px;
    span {
      width: 130px;
      padding: 0px 20px;
      // border: 1px solid #000;
      cursor: pointer;
      font-size: 14px;
      color: @theme-color;
      i {
        font-size: 16px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        line-height: 19px;
        text-align: center;
        color: rgb(253, 250, 250);
        background-color: @theme-color;
      }
    }
  }
  .big-box {
    background-color: #fff;
    margin: 0 30px;
    padding: 30px 0;
    display: flex;
    flex-wrap: wrap;
    .box {
      cursor: pointer;
      width: 100%;
      // min-width: 600px;
      // max-width: 100%;
      height: 300px;
      margin-bottom: 24px;
      box-sizing: border-box;
      margin-right: 24px;
      background: #ebfaf3;
      border-radius: 7px;
      padding: 20px 24px;
      .tu {
        height: 300px;
        margin-top: 5px;
      }
      .tu-left {
        width: 65%;
      }
      .tu-right {
        width: 32%;
      }
    }
  }
}
</style>
